const keywords = [
  "All",
  "Technology",
  "Productivity",
  "Healthcare",
  "Meditation",
  "Lifestyle",
  "Motivation",
  "Awareness",
  "Programming",
  "Gaming",
  "Music",
  "Career",
  "Creativity",
];

export default keywords;
